// src/utils/libraryUtils.js

export const normalizeColorKey = (raw) => {
  if (!raw) return "blue";
  const v = String(raw).trim().toLowerCase();
  const allowed = ["blue", "orange", "purple", "emerald", "red", "gray"];
  return allowed.includes(v) ? v : "blue";
};

export const checkEnabled = (val) => {
  if (val === false) return false;
  if (String(val) === "false") return false;
  return true;
};

export const extractReviewerDoc = (payload) => {
  if (!payload) return null;
  if (Array.isArray(payload)) return payload[0] || null;
  return payload.reviewer || payload.data || payload.result || payload.file || payload;
};

export const formatDate = (value) => {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return "Invalid Date";
  }
};

export const chunk = (arr, size) => {
  const out = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};

// The core verification logic
export const computeVerified = (obj) => {
  if (!obj) return false;

  // 1. Direct booleans (explicit only)
  if (obj.verified !== undefined) return Boolean(obj.verified);
  if (obj.isVerified !== undefined) return Boolean(obj.isVerified);
  if (obj.is_verified !== undefined) return Boolean(obj.is_verified);

  // 2. Nested verification objects (explicit only)
  if (obj.verification) {
    if (obj.verification.verified !== undefined) return Boolean(obj.verification.verified);
  }

  // 3. Meta fallback from secure detail payload
  if (obj.meta) {
    if (obj.meta.verified !== undefined) return Boolean(obj.meta.verified);
  }

  // NOTE:
  // Do not infer verification from txHash/status strings.
  // A reviewer is "verified" only when an explicit verified flag is present.
  return false;
};
